import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  uploadvideoEvent: "",
  uploadVideoWeek: "",
  uploadVideoWeekName: "",
  uploadVideoEventType: "",
  uploadVideoOffSeasonEventName: "",
  otherEventName: "",
  practice: "",
  opponentName: "",
  uploadPlaylistName: "",
  playlistData: "",
};

export const VideoScheduleReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.ADD_VIDEO_SCHEDULE_INFORMATION:
      return {
        ...state,
        [payload?.fieldName]: payload?.value,
      };

    case ActionTypes.RESET_VIDEO_SCHEDULE_EVENT_DATA:
      const newState = { ...state };

      payload?.forEach((fieldName) => {
        newState[fieldName] = "";
      });
      return newState;

    case ActionTypes.ADD_PLAYLIST_DATA:
      return {
        ...state,
        playlistData: payload,
      };

    default:
      return state;
  }
};
